import React from 'react'

const Training = () => {
    const stats = [
  { value: '500+', label: 'Partner Institutions' },
  { value: '25,000+', label: 'Students Trained' },
  { value: '150+', label: 'Industry Mentors' },
  { value: '50+', label: 'Robotics Labs Setup' },
];

  return (

    <div className="training-section align-items-center">
  <div className="container align-items-center">
    <h2 className="fw-bold mb-3 text-white">Transforming Education with Technology</h2>
    <p className="lead mb-5">
      Leading institutions trust our platform for comprehensive IT training and innovative<br />
      learning solutions
    </p>
    <div className="training-stats">
      {stats.map((item, index) => (
        <div className="training-stat-item" key={index}>
          <h3>{item.value}</h3>
          <p>{item.label}</p>
        </div>
      ))}
    </div>
  </div>
</div>

  )
}

export default Training
